module.exports = __webpack_public_path__ + "static/media/halfcircle_top.d053c9b7.png";